import React, { SyntheticEvent, useContext, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useDebounce, useLocalStorage } from 'react-use'
import toggleFavorite from 'shared/redux/favorites'
import MessageContext from '../context/message'
import UserContext from '../context/user'
// @ts-ignore
import css from './favorite.css'

type Props = {
    id: string | number
    url: string
    isFavorite: boolean
    className?: string
    showLabel?: boolean
    onClick?: Function
    scale?: number
    toggleFavorite: Function
}

const ANIMATION_TIME = 500

const Favorite = ({ id, url, showLabel = false, className, scale, toggleFavorite, onClick, isFavorite }: Props) => {
    const [hasSeenLocalFavMessage, setHasSeenLocalFavMessage] = useLocalStorage('has-seen-local-fav-message', false)
    const transform = `scale(${scale || 1})`
    const style = {
        WebkitTransform: transform,
        MozTransform: transform,
        Transform: transform,
    }

    const { user, isLoggedIn, removeFavorite, addFavorite, localFavorites, favorites } = useContext(UserContext)

    // check our favorites from the user
    isFavorite = isFavorite || [...favorites, ...localFavorites].indexOf(id) !== -1

    const { sendMessage } = useContext(MessageContext)
    const showAnimation = useRef(false)
    const [isActive, setIsActive] = useState(isFavorite)
    useEffect(() => {
        if (!showAnimation.current) {
            setIsActive(isFavorite)
        }
    }, [isFavorite])

    useDebounce(
        () => {
            if (showAnimation.current) {
                if (isLoggedIn) {
                    toggleFavorite({ id, url }, user)
                    onClick?.({ id, url, is_favorite: isActive })
                } else {
                    if (!isActive) {
                        removeFavorite(id)
                    } else {
                        addFavorite(id)
                    }
                    if (!hasSeenLocalFavMessage) {
                        setHasSeenLocalFavMessage(true)
                        sendMessage(`Favorite saved! Access your favorites from the user menu.`, 'success')
                    }
                }
                // set this back to false after the debounce and the animation
                showAnimation.current = false
            }
        },
        ANIMATION_TIME,
        [isActive]
    )

    const doTheToggle = (e: SyntheticEvent<HTMLElement, Event>) => {
        e.preventDefault()
        e.stopPropagation()
        // flag this so we show the animation
        showAnimation.current = true
        setIsActive(!isActive)
    }

    return (
        <div className={className ? `${className} ${css.favorite}` : css.favorite} style={style} onClick={doTheToggle}>
            <div
                className={isActive ? css.favoriteIconActive : css.favoriteIcon}
                data-animated={showAnimation.current}
            />
            {showLabel && <span>Favorite</span>}
        </div>
    )
}

export default connect(undefined, { toggleFavorite })(Favorite)
